module.exports = __webpack_public_path__ + "img/img32.5d6e46e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img32.jpg
// module id = 330
// module chunks = 0